import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from './api/config';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const DoctorList = () => {
  const [doctors, setDoctors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${BASE_URL}/get-doctors.php`).then(res => {
      setDoctors(res.data);
    });
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Our Doctors</h2>
      <div className="row">
        {doctors.map(doc => (
          <div className="col-md-4" key={doc.id}>
            <div className="card mb-4 shadow-sm">
              <img src={doc.photo} className="card-img-top" alt={doc.name} />
              <div className="card-body">
                <h5>{doc.name}</h5>
                <p>{doc.specialization}</p>
                <button className="btn btn-primary" onClick={() => navigate(`/slots/${doc.id}`)}>
                  Book Appointment
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default DoctorList;
